// Note: this is a temporary hook that is being used to standardize the process
// of setting user data in Apollo Client. This will be replaced within the next
// 2 weeks, once we update all instances to use Jotai-based state instead.

import { useApolloClient } from '@apollo/client';

import { GET_CURRENT_USER_CLIENT } from 'mocks/queries';

const useResetUserData = () => {
  const apolloClient = useApolloClient();

  const resetUserData = () => {
    apolloClient.writeQuery({
      query: GET_CURRENT_USER_CLIENT,
      data: { user: null, __typename: 'UIUser' },
    });
  };

  return resetUserData;
};

export default useResetUserData;
